import React from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import { Redirect } from 'react-router-dom'
import { DataContext } from '../../../state/DataContext/DataContext';
import { auth } from '../../../utils/firebase';

export default function RedirectIfNotLoggedIn() {

    const [user] = useAuthState(auth);
    const { data, actions } = React.useContext(DataContext);

    return (<>{!user && <Redirect to={`/login`} />}</>)
}
